import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {CommentIcon} from '@primer/octicons-react'
import {ForYouItem} from '../../shared/ForYouItem'
import {ForYouLeadingIcon} from '../../shared/ForYouLeadingIcon'
import {getVariantComment, ThreadGroupVariantLabels, ThreadGroupVariant} from '../util/classify-thread'
import {ExpandedThread} from './ExpandedThread'
import {ThreadActions} from './ThreadActions'
import {ThreadTitle} from './ThreadTitle'

export function ForYouThreadItem({thread, variant}: {thread: Thread; variant: ThreadGroupVariant}) {
  return (
    <ForYouItem
      key={thread.id}
      itemName={threadItemName(variant)}
      title={<ThreadTitle thread={thread} variant={variant} />}
      ariaLabel={threadTitleAriaLabel(thread, variant)}
      leadingVisual={<ForYouLeadingIcon icon={CommentIcon} />}
      actionSlot={<ThreadActions thread={thread} />}
      padding="none"
    >
      <ExpandedThread thread={thread} />
    </ForYouItem>
  )
}

function threadTitleAriaLabel(thread: Thread | null | undefined, variant: ThreadGroupVariant) {
  const author = thread ? getVariantComment(thread, variant)?.author : undefined
  const message = ThreadGroupVariantLabels[variant] || 'commented'

  if (!author) {
    // TODO: add ghost user support
    return message
  }

  return `${author.login} ${message}`
}

function threadItemName(variant: ThreadGroupVariant) {
  switch (variant) {
    case ThreadGroupVariant.Replied:
      return 'replied-comment'
    case ThreadGroupVariant.RepliedMentioned:
      return 'replied-mention-comment'
    case ThreadGroupVariant.Mentioned:
      return 'mentioned-comment'
    case ThreadGroupVariant.Resolved:
      return 'resolved-comment'
    case ThreadGroupVariant.Commented:
    default:
      return 'commented-comment'
  }
}
